// extracted by mini-css-extract-plugin
export default {"job_details":"styles_job_details__08xEV","square":"styles_square__R8IGX","title":"styles_title__o+4R5","detail":"styles_detail__lXkeO"};